import AnimatedListItem from './animated_list_item'

export default AnimatedListItem
